// extracted by mini-css-extract-plugin
export default {"loginErrorBox":"LoginErrorBox_loginErrorBox__aLvqc","loginErrorBoxTitle":"LoginErrorBox_loginErrorBoxTitle__3foba","loginErrorBoxBody":"LoginErrorBox_loginErrorBoxBody__GhOe4"};